import { store } from '../../store';
import { showConfirmationModal } from '../../actions/modalActions';

export const bookingMoveRepeatedDependenciesErrorHandler = ({ cleanUpAction }) => ({
    predicate: error => error?.data?.error?.enum === 'ENTITY_MOVE_NOT_ALLOWED_REPEATED_DEPENDENCIES',
    handler: function(error, action) {
        store.dispatch(
            showConfirmationModal(
                () => {
                    store.dispatch({
                        ...action,
                        payload: {
                            ...(action.payload || {}),
                            options: {
                                ...(action.payload?.options || {}),
                                allowToRemoveDependenciesOfRepeat: true,
                            },
                        },
                    });
                },
                'Booking update warning',
                `You're trying to move a dependent, repeated booking. New bookings will be created, and existing dependencies might be lost.`,
                {
                    withCancel: true,
                    withEscButton: true,
                    confirmButtonText: 'Accept',
                    cancelButtonText: 'Cancel',
                    cancelActionOnHide: true,
                    onReject: cleanUpAction,
                }
            )
        );
    },
});
